/* eslint-disable react-hooks/exhaustive-deps */

import { useEffect, useState } from 'react';
import { useAppDispatch } from '../../store.model';
import { fetchCurrentSensorDataControlUnits } from '../actions/asyncThunks';
import { SensordataNewest } from '../../../service/monitoring/monitoring.model';

interface Props {
  commanderId: string;
}
/**
 * Get and fetch current sensor information of a commander
 * @param deviceId
 * @returns [sensorData, loading, error]
 * 
 * @usage
´´´ts
const [sensorData, loading, error] = useGetCurrentSensorInformation({ deviceId: "UUUID_DEVICE" })
´´´
 */
export function useGetCurrentSensorInformation(props: Props) {
  const { commanderId } = props;
  // initial fetch
  const dispatch = useAppDispatch();

  const [result, setResult] = useState<null | SensordataNewest[]>(null);
  const [fetch, setFetch] = useState(!result);
  const [error, setError] = useState<null | Error>(null);

  useEffect(() => {
    if (fetch) {
      const fetchData = async () => {
        try {
          const result = await dispatch<any>(
            fetchCurrentSensorDataControlUnits(commanderId)
          );
          setResult(result.payload);
        } catch (err) {
          setError(err as Error);
        } finally {
          setFetch(false);
        }
      };
      fetchData();
    }
  }, [props.commanderId, fetch]);

  return { sensorData: result, loading: fetch, error };
}
